import {useEffect} from 'react';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';
import {Button} from '~library/atoms/Button';
import {useSuccessPageRokt} from './useSuccessPageRokt';

import './SuccessRokt.sass';

type SuccessRoktProps = {
  onClose?: () => void;
  onPlacementClosed: () => void;
  showFooter?: boolean;
};

export const SuccessRokt = ({onClose, onPlacementClosed, showFooter}: SuccessRoktProps) => {
  const {subscribe} = useSuccessPageRokt();

  useEffect(() => {
    subscribe('PLACEMENT_CLOSED', onPlacementClosed);
  }, [onPlacementClosed, subscribe]);

  return (
    <Step
      header={<Header title="Your RSVP is confirmed" onClose={onClose} />}
      footer={
        showFooter ? (
          <Button
            variant="primary"
            size="large"
            data-qa-id="af-rsvp-done"
            onClick={onClose}
            className="rsvp-step__footer__cta"
          >
            Done
          </Button>
        ) : null
      }
      description="From Evite: optional offers and worthy causes"
    >
      <div id="rokt_rsvpcontainer" />
    </Step>
  );
};
